import Button from './Button';

interface Props {
  data: BtnListProps[];
  direction?: 'row' | 'column' | 'wrap';
}

const ButtonsList = ({ data, direction = 'wrap' }: Props) => (
  <div className={`d-flex flex-${direction} gap-2`}>
    {data
      .filter((btn) => !btn.isHidden)
      .map((btn, index) => (
        <Button key={`button_${index}`} type={btn.type ?? 'button'} {...btn} />
      ))}
  </div>
);

export default ButtonsList;
